import { cn } from '@dreamstack/util/src/cn'
import type { FunctionComponent } from 'react'

export type SimpleAccordionProps = { widgetType?: string; children: any }
const StyledDl = ({
  widgetType,
  className,
  children,
  ...rest
}: React.PropsWithChildren<{
  widgetType?: string
  className?: string
}>) => (
  <dl
    className={cn(
      !widgetType || widgetType === 'DefaultAccordion'
        ? 'divide-y-2 divide-gray-200 border-t-2 border-b-2 border-gray-200'
        : 'divide-y-0 border-t-0 border-b-0',
      className
    )}
    {...rest}
  >
    {children}
  </dl>
)

export const SimpleAccordion: FunctionComponent<
  React.PropsWithChildren<SimpleAccordionProps>
> = ({ widgetType, children }) => {
  return (
    <>
      <StyledDl widgetType={widgetType}>{children}</StyledDl>
    </>
  )
}
